module.exports = __webpack_public_path__ + "static/roi-carousel-3f9605e8cb85eed47bfa207a29d25a7f.svg";